<div class="p-4 md:p-6 lg:w-[var(--mixed-content-card-container-width)] lg:mx-auto">
  <div class="mt-60 flex justify-center">
      @if ((errorInfo$ | async); as errorInfo) {
                            <myupdates-error-box class="error-box-white-style"
                           [errorTitle]="'goto.error_goto_redirect_title' | translate"
                           [errorText]="errorText">
              </myupdates-error-box>
      } @else {
        <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
      }
  </div>
</div>

